module.exports = __webpack_public_path__ + "img/harveys2.2c338e48.png";